module.exports = __webpack_public_path__ + "img/siren-icon.013f409f.svg";